
import { StakingPanel } from "@/components/StakingPanel";
import { Card, PageHeader } from "@/components/ui";
import { TOKEN_SYMBOL } from "@/lib/config";
import { STAKING_ENABLED } from "@/lib/features";
import { usePageMeta } from "@/lib/page-meta";
import { NotFoundPage } from "./NotFoundPage";


export function StakingPage() {
  usePageMeta({
    title: "Staking",
    description:
      "Kunci AsetQu untuk jangka waktu tertentu dan terima reward yang sudah didanai di muka.",
  });

  if (!STAKING_ENABLED) return <NotFoundPage />;

  return (
    <div className="page-shell page-shell--wide">
      <PageHeader
        context="Reward didanai di muka"
        title="AsetQu Staking"
        description={
          <>
          Kunci {TOKEN_SYMBOL} untuk jangka waktu tertentu. Reward diambil dari
          pool yang sudah didanai sebelumnya — kontrak tidak dapat mencetak
          token baru.
          </>
        }
        meta={
          <>
            <span>Reward fixed saat stake</span>
            <span>Principal non-custodial</span>
          </>
        }
      />

      <StakingPanel />

      <div className="content-split">
        <Card title="Cara kerja reward" className="ui-card--compact">
          <div className="content-prose">
          <p>
            <strong className="text-ink">Reward dikunci saat Anda stake.</strong>{" "}
            Kontrak menghitungnya sekali, di transaksi stake Anda, lalu
            menyisihkannya dari pool. Angka yang Anda lihat sebelum menekan
            tombol adalah angka yang akan Anda terima — tidak berubah oleh
            berapa banyak orang lain yang ikut setelah Anda.
          </p>
          <p>
            <strong className="text-ink">Stake ditolak kalau pool tidak cukup.</strong>{" "}
            Kontrak lebih memilih menolak stake baru daripada menerima uang yang
            rewardnya belum bisa dibayar. Posisi yang sudah berjalan tidak
            pernah dikurangi karena pool menipis.
          </p>
          <p>
            <strong className="text-ink">Persentase plan berlaku per periode, bukan per tahun.</strong>{" "}
            Plan 10% dengan kunci 90 hari memberi 10% dari principal Anda setelah
            90 hari. Angka &ldquo;setara APR&rdquo; hanya konversi untuk
            perbandingan.
          </p>
          </div>
        </Card>

        <Card title="Batas kewenangan operator" className="ui-card--compact">
          <div className="content-prose">
          <p>
            Operator program <strong className="text-ink">tidak dapat</strong>{" "}
            mengambil principal Anda, membatalkan posisi yang berjalan,
            memperpanjang masa kunci, mengubah reward yang sudah dijanjikan, atau
            menghalangi penarikan pada saat jatuh tempo. Batasan ini tertanam di
            kontrak, bukan janji operasional.
          </p>
          <p>
            Operator hanya bisa menarik sisa anggaran reward yang{" "}
            <em>belum</em> dijanjikan ke posisi mana pun. Bahkan jika seluruh
            sisa itu ditarik, setiap staker tetap dibayar penuh — hal itu diuji
            secara eksplisit di test suite kontrak.
          </p>
          <p>
            Jeda darurat (<code className="font-mono">pause</code>) hanya
            menghentikan stake baru. Penarikan tidak pernah ikut terjeda: jeda
            yang bisa mengunci dana pengguna bukan tombol darurat.
          </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
